import type { Descriptivo } from "@/componentes/cargos/cargo"

/**
 * Lo que el cargo hace según los procesos: se arma solo, y aquí sólo se lee.
 *
 * ⚠ **Va APARTE de las escritas a mano, y no se edita.** Sale de los pasos de los
 * procesos y se mantiene sola; mezclarla con las de arriba haría imposible saber
 * cuáles se actualizan al cambiar un proceso y cuáles hay que revisar a mano. Se
 * corrige en «Procesos».
 */
export function FuncionesDelFlujo({ descriptivo }: { descriptivo?: Descriptivo }) {
  return (
    <>
      <h3 className="rotulo mt-6 mb-2">Funciones que vienen del flujo</h3>
      {descriptivo === undefined ? null : descriptivo.del_flujo.length === 0 &&
        descriptivo.procesos_a_cargo.length === 0 ? (
        <p className="superficie p-3 text-sm" style={{ color: "var(--fg-muted)" }}>
          Este cargo no responde por ningún paso todavía. Se le asignan en «Procesos», y aparecen
          aquí solas.
        </p>
      ) : (
        <div className="superficie overflow-hidden">
          {descriptivo.procesos_a_cargo.length > 0 && (
            <p
              className="border-b px-3 py-2 text-xs"
              style={{ borderColor: "var(--border)", color: "var(--fg-muted)" }}
            >
              Responde por el proceso entero: {descriptivo.procesos_a_cargo.join(" · ")}
            </p>
          )}
          <ul>
            {descriptivo.del_flujo.map((f, i) => (
              <li
                // El indice entra en la clave a proposito: dos pasos del mismo proceso
                // pueden llamarse igual —«Revisar» aparece en varios— y sin el la
                // clave se repetiria. La lista es de solo lectura y no se reordena
                // aqui, asi que el indice es estable.
                // biome-ignore lint/suspicious/noArrayIndexKey: dos pasos pueden llamarse igual
                key={`${f.proceso_id}-${f.titulo}-${i}`}
                className="px-3 py-2 text-sm"
                style={i === 0 ? undefined : { borderTop: "1px solid var(--cristal-filo)" }}
              >
                <span className="block">{f.titulo}</span>
                {/* De qué proceso sale: sin esto el descriptivo es una lista de frases
                    sueltas que nadie puede rastrear. */}
                <span className="block text-xs" style={{ color: "var(--fg-muted)" }}>
                  {f.proceso}
                </span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </>
  )
}
